export default __webpack_public_path__ + "static/media/s.fe78d3d2.svg";